module.exports = __webpack_public_path__ + "img/cert-product-mob.637d1be.webp";